/**
 * @ngdoc controllers
 * @memberof mercury.modules.reports
 * @name ReportsRevenueBudgetCtrl
 */
angular.module('mercury.modules.reports.revenue')
.controller('ReportsRevenueBudgetCtrl', ["Budgets", "$scope", "reporttime", "ReportSales", "$q", "$filter", "title", function(Budgets, $scope, reporttime, ReportSales, $q, $filter, title) {
  reporttime.setAllowedTypes(['day', 'week', 'month']);
  reporttime.defaultType = 'week';
  title.set('Budget vs Actual Report');

  $scope.graphCols = [
    {label: 'Period', type: 'string', key: 'startTime', filter: 'reporttimeformat'},
    {label: 'Actual', type: 'number', key: 'invoices', filter: 'currency'},
    {label: 'Budget', type: 'number', key: 'budget', filter: 'currency'}
  ];

  $scope.loading = $q.all({
    sales: ReportSales.getByInterval(reporttime.start(), reporttime.end(), '01:00:00:00'),
    budgets: Budgets.getAll(reporttime.start(), reporttime.end())
  });

  $scope.loading.then(function(results) {
    $scope.sales = results.sales;

    var budgetAmounts = {};
    angular.forEach(results.budgets, function(budget) {
      budgetAmounts[moment(budget.date).mStartOf('day').format()] = budget.amount;
    });

    angular.forEach($scope.sales, function(sales) {
      sales.budget = budgetAmounts[moment(sales.startTime).format()] || 0;
      sales.diffAmount = sales.invoices - sales.budget;
      sales.diffPercent = sales.budget !== 0 ? (sales.diffAmount / sales.budget) * 100 : 0;
    });
  });
}]);
